module.exports = __webpack_public_path__ + "assets/icon-smartphone.d9cb5e54.svg";